<template>
  <div class="shunyi-page" >
    <div v-if="test">{{ test }}</div>

    <div class="user-info">
      <div class="user-info__name">{{ displayHospitalName }}</div>
      <div class="user-info__phone">{{ maskedPhone }}</div>
    </div>

    <!-- 顶部标语图片 -->
    <div class="slogan-wrapper">
      <my-img :url="imgSlogan" class="slogan-img"/>
    </div>
  <div class="slogan-wrapper" style="margin-top:-60px">
      <my-img :url="imgFuncTop" class="slogan-img" style="padding: 0 16px;box-sizing: border-box;" />
    </div>
    <div style="width: auto;margin:  0 16px ;background-color: white;box-sizing: border-box;border-radius: 0 0 16px 16px;">
      <!-- 快捷入口：科普园地、训练方案、远程指导、训练打卡 -->
      <div class="three-btns">
        <div class="three-btns__item three-btns__item--green" @click="tapKepuList">科普园地</div>
        <div class="three-btns__item three-btns__item--blue" @click="tapPlanList">训练方案</div>
        <div class="three-btns__item three-btns__item--purple" @click="tapRemoteGuide">远程指导</div>
        <div class="three-btns__item three-btns__item--orange" @click="tapDakaHome">训练打卡</div>
      </div>
      <div class="service-purchase-entry" @click="tapServicePurchase">服务购买</div>
    </div>

    <!-- 顶部活动图（位于 banner 之上） -->
    <div class="banner-top-wrapper">
      <div
        class="banner-top-image"
        :class="{ 'banner-top-image--jelly': isBannerTopJelly }"
        @click="onBannerTopClick"
      >
        <my-img :url="bannerTopImage" class="banner-top-image__img" />
      </div>
    </div>

    <!-- 轮播内容包装器 -->
    <div v-if="showBannerContent" class="banner-content-wrapper">
      <!-- 轮播图 -->
      <div class="banner" v-if="hospital.bannerList">
        <div class="swipe-wrapper">
          <van-swipe class="swipe-container" :autoplay="3000" @change="onChange" :show-indicators="false" ref="swipe">
            <van-swipe-item v-for="(banner, index) in hospital.bannerList"
                           :key="index"
                           @click="handleBannerClick(banner)">
              <my-img :url="banner.img" class="banner-image"/>
              <div v-show="false" class="banner-title-overlay">
                {{ banner.title || `服务${index + 1}` }}
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="custom-indicator">
            {{ current + 1 }}/{{ hospital.bannerList?.length || 0 }}
          </div>
        </div>
      </div>

      <!-- 轮播标题标签导航 -->
      <div class="banner-titles-wrapper" v-if="false">
        <div class="banner-titles-container">
          <div
            v-for="(banner, index) in hospital.bannerList"
            :key="index"
            :class="['banner-title-bubble', { active: current === index }]"
            :style="getBubbleStyle(index)"
            @click="selectBanner(index)"
          >
            {{ banner.title || `服务${index + 1}` }}
          </div>
        </div>
      </div>
    </div>

    <!-- 科普园地 -->
    <div class="science-popularization-section">
      <div class="section-header">
        <div class="section-header__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 2L2 7L10 12L18 7L10 2Z" fill="#5CB8E6" opacity="0.8"/>
            <path d="M2 9L10 14L18 9" stroke="#5CB8E6" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M2 13L10 18L18 13" stroke="#5CB8E6" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="section-header__title">科普园地</h3>
      </div>

      <div class="science-popularization__grid">
        <div
          v-for="(item, index) in sciencePopularizationList"
          :key="index"
          class="science-popularization__card"
          :style="{ background: item.gradient }"
          @click="handleKepuCardClick(item)"
        >
          <div class="science-popularization__card-icon">
            <div class="icon-wrapper" v-html="item.icon"></div>
          </div>
          <div class="science-popularization__card-label">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showRemoteGuidePopup"
      round
      closeable
      class="remote-guide-popup"
    >
      <div class="remote-guide-popup__content">
        <div class="remote-guide-popup__title">远程指导</div>
        <div class="remote-guide-popup__tip">长按识别二维码，进入远程康复指导</div>
        <img
          class="remote-guide-popup__qrcode"
          :src="remoteGuideQr"
          alt="远程指导二维码"
        >
      </div>
    </van-popup>

    <van-action-sheet
      v-model="showServicePurchaseSheet"
      :actions="servicePurchaseActions"
      cancel-text="取消"
      close-on-click-action
      description="脊柱侧弯防治训练服务，请选择"
      @select="selectServicePurchase"
    />

  </div>
</template>

<script>
import MyImg from '@/h5/doucan/components/MyImg.vue'
import SpineConfigDao, { DEFAULT_SPINE_ICON } from '@/h5/doucan/network/SpineConfigDao'
import SpineScienceDao from '@/h5/doucan/network/SpineScienceDao'
import { ActionSheet, Toast } from 'vant'
import PlanDao from '@/h5/doucan/network/PlanDao'
import bannerShaicha from '@/h5/doucan/assets/shunyi/banner/banner-shaicha.png'
import bannerZhiliao from '@/h5/doucan/assets/shunyi/banner/banner-zhiliao.png'
import bannerYufang from '@/h5/doucan/assets/shunyi/banner/banner-yufang.png'
import appBgTop from '@/h5/doucan/assets/shunyi/app-bg-top.png'
import imgSlogan from '@/h5/doucan/assets/shunyi/img_slogan.png'
import imgFuncTop from '@/h5/doucan/assets/shunyi/img_func_top.png'
import bannerTopImage from '@/h5/doucan/assets/banner_20260130105957.png'
import remoteGuideQr from '@/h5/doucan/assets/shunyi/remote_guide.jpg'

const GUOXIN_MINI_PROGRAM_APP_ID = 'wxac4c0e4328817751'
const GUOXIN_MINI_PROGRAM_PAGE_PATH = 'packages/service/detail/index'

export default {
  components: {
    MyImg,
    [ActionSheet.name]: ActionSheet
  },
  data () {
    return {
      test: '',
      current: 0,
      showBannerContent: false,
      userGender: '', // 用户性别
      thirdPartyUserId: '', // 第三方系统用户ID
      appBgTop,
      imgSlogan,
      imgFuncTop,
      bannerTopImage,
      remoteGuideQr,
      isBannerTopJelly: false,
      showRemoteGuidePopup: false,
      showServicePurchaseSheet: false,
      servicePurchaseActions: [
        { name: '小程序基础版', productId: '120068' },
        { name: '智能硬件加强版', productId: '120069' }
      ],
      hospital: {
        id: 'shunyi001',
        name: '健康顺德脊柱侧弯康复中心',
        mainImg: 'https://cdn.keihong.tech/img/202412091556356.png',
        bannerList: [
          {
            title: '脊柱筛查',
            img: bannerShaicha,
            targetCategoryKey: 'spine_screening'
          },
          {
            title: '康复治疗',
            img: bannerZhiliao,
            targetCategoryKey: 'spine_assessment_treatment'
          },
          {
            title: '预防保健',
            img: bannerYufang,
            targetCategoryKey: 'spine_daily_prevention'
          }
        ],
        doctors: [
          {
            name: '脊柱侧弯康复专家团队',
            img: 'https://cdn.keihong.tech/img/202412091637331.png'
          },
          {
            name: '物理治疗师团队',
            img: 'https://cdn.keihong.tech/img/202412091639275.png'
          }
        ]
      },
      sciencePopularizationList: []
    }
  },
  mounted () {
    console.log('健康顺德脊柱侧弯康复主页', this.$route.query)
    const query = this.$route.query

    // 兼容健康顺德小程序旧入口：如果仍打开首页并携带加密授权参数，则转交授权页处理。
    if (query.appId && query.content) {
      this.$router.replace({ path: '/Shunyi/auth', query })
      return
    }

    this.loadSpineConfig()
    this.loadScienceCategories()

    // 首次进入本页，清除可能残留的本地持久化缓存（避免读到历史 H5 登录账号）
    try {
      const FIRST_FLAG_KEY = 'shunyi_home_first_visit_cleared_v1'
      if (!sessionStorage.getItem(FIRST_FLAG_KEY)) {
        const keysToRemove = [
          // 登录/鉴权相关
          'token', 'shunyi_token', 'user', 'user_profile', 'vuex', 'persist:root',
          // 顺义场景下透传/缓存的用户字段
          'shunyi_user_gender', 'shunyi_user_id', 'shunyi_user_name', 'shunyi_user_phone',
          'shunyi_user_birthdate', 'shunyi_user_idcard',
          // 健康顺德小程序院区字段
          'shunyi_hospital_code', 'shunyi_hospital_name',
          'shunyi_register_hospital_id', 'shunyi_register_hospital_business_id',
          'shunyi_register_hospital_name'
        ]
        keysToRemove.forEach(k => {
          try { sessionStorage.removeItem(k) } catch (e) {}
          try { localStorage.removeItem(k) } catch (e) {}
        })
        // 同步清理 Vuex 中的用户登录状态（若有该 mutation）
        try { this.$store.commit('user/logout') } catch (e) {}
        sessionStorage.setItem(FIRST_FLAG_KEY, '1')
        console.log('已执行首次进入清缓存')
      }
    } catch (e) {
      console.warn('清缓存失败（忽略）', e)
    }

    if (query.openid) {
      this.$store.commit('setIsWxapp', true)
      this.$store.commit('setWxAppOpenId', query.openid)
    }

    // 处理新增参数 - 存储到 sessionStorage 供个人中心页面使用
    if (query.gender) {
      console.log('用户性别:', query.gender)
      this.userGender = query.gender
      sessionStorage.setItem('shunyi_user_gender', query.gender)
    }

    if (query.userId) {
      console.log('第三方系统用户ID:', query.userId)
      this.thirdPartyUserId = query.userId
      sessionStorage.setItem('shunyi_user_id', query.userId)
    }

    if (query.name) {
      console.log('用户姓名:', query.name)
      sessionStorage.setItem('shunyi_user_name', query.name)
    }

    if (query.phone) {
      console.log('用户电话:', query.phone)
      sessionStorage.setItem('shunyi_user_phone', query.phone)
    }

    if (query.hospitalName) {
      console.log('医院名称:', query.hospitalName)
      sessionStorage.setItem('shunyi_hospital_name', query.hospitalName)
      sessionStorage.setItem('shunyi_register_hospital_name', query.hospitalName)
    }

    if (query.birthDate || query.birthday) {
      const birthDate = query.birthDate || query.birthday
      console.log('出生日期:', birthDate)
      sessionStorage.setItem('shunyi_user_birthdate', birthDate)
    }

    if (query.idCard || query.idNumber) {
      const idCard = query.idCard || query.idNumber
      console.log('证件号码:', idCard)
      sessionStorage.setItem('shunyi_user_idcard', idCard)
    }

    let hospitalId = query.hospitalId || sessionStorage.getItem('shunyi_register_hospital_id')
    if (hospitalId) {
      console.log('hospitalId', hospitalId)
      console.log('phone', query.phone)
      console.log('name', query.name)
      console.log('gender', query.gender)
      console.log('userId', query.userId)
      this.$store.commit('user/setQrCodeHospitalId', hospitalId)
    } else {
      hospitalId = this.$store.state.user.qrCodeHospitalId
    }

    // 获取医院信息（合并时保留本地固定 bannerList）
    const customHospital = this.getHospitalById(hospitalId)
    if (customHospital) {
      const localBannerList = (this.hospital && this.hospital.bannerList) ? this.hospital.bannerList : []
      this.hospital = Object.assign({}, customHospital, {
        bannerList: localBannerList && localBannerList.length > 0 ? localBannerList : customHospital.bannerList
      })
    }

    const sessionHospitalName = sessionStorage.getItem('shunyi_register_hospital_name') ||
      sessionStorage.getItem('shunyi_hospital_name')
    if (sessionHospitalName) {
      this.hospital = Object.assign({}, this.hospital, {
        name: sessionHospitalName
      })
    }

    this.$store.commit('user/setQrCodeHospital', this.hospital.name)
    console.log(this.$store.state.user.qrCodeHospital)

    // 获取URL参数后进行静默登录
    // 小程序场景优先：只要来自小程序且带有用户标识，则强制使用URL参数覆盖登录
    // 其他场景：未登录且有URL参数时执行
    const isLoggedIn = this.$store.state.user.profile.isLogin && this.$store.state.user.profile.token
    const hasUrlParams = query.phone || query.userId || query.name
    const fromWxapp = query.from === 'wxapp'

    if ((fromWxapp && hasUrlParams) || (!isLoggedIn && hasUrlParams)) {
      this.silentLogin(query)
    } else if (isLoggedIn) {
      console.log('用户已登录，跳过静默登录')
    } else {
      console.log('无URL参数，跳过静默登录')
    }
  },
  methods: {
    async loadSpineConfig () {
      try {
        const config = await SpineConfigDao.load()
        if (config.hospital) {
          const localBannerList = (this.hospital && this.hospital.bannerList) || []
          const remoteBannerList = (config.hospital.bannerList || []).map((banner, index) => {
            const localBanner = localBannerList[index] || {}
            return Object.assign({}, localBanner, banner, {
              img: banner.img || localBanner.img || ''
            })
          })
          this.hospital = Object.assign({}, this.hospital || {}, config.hospital, {
            bannerList: remoteBannerList.length > 0 ? remoteBannerList : localBannerList,
            doctors: config.hospital.doctors && config.hospital.doctors.length > 0 ? config.hospital.doctors : (this.hospital.doctors || [])
          })
        }
        if (config.courseSort) {
          sessionStorage.setItem('shunyi_spine_course_sort', config.courseSort)
        }
      } catch (e) {
        console.warn('脊柱侧弯配置加载失败，使用本地默认配置', e)
      }
    },
    async loadScienceCategories () {
      try {
        const categories = await SpineScienceDao.loadCategories()
        this.sciencePopularizationList = (categories || []).map(item => ({
          label: item.name,
          category: item.categoryKey,
          gradient: '#FFFFFF',
          icon: DEFAULT_SPINE_ICON
        }))
      } catch (e) {
        console.warn('加载脊柱科普分类失败', e)
        this.sciencePopularizationList = []
      }
    },
    onBannerTopClick () {
      if (this.isBannerTopJelly) {
        this.isBannerTopJelly = false
      }
      this.$nextTick(() => {
        this.isBannerTopJelly = true
        window.setTimeout(() => {
          this.isBannerTopJelly = false
          // 动画结束后跳转到脊柱保健操视频园地
          this.$router.push('/shunyi/video/list')
        }, 520)
      })
    },
    // 快捷入口按钮
    tapKepuList () {
      const element = document.querySelector('.science-popularization-section')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    tapRemoteGuide () {
      this.showRemoteGuidePopup = true
    },
    handleKepuCardClick (item) {
      // 点击科普卡片，跳转到对应分类的文章列表页
      if (item.category) {
        this.$router.push({
          path: '/shunyi/article/list',
          query: {
            category: item.category
          }
        })
      } else {
        this.$toast({
          message: `${item.label} - 内容开发中`,
          position: 'middle',
          duration: 1500
        })
      }
    },
    async tapPlanList () {
      const isLoggedIn = this.$store.state.user.profile.isLogin && this.$store.state.user.profile.token
      const defaultGuestPhone = '13610164743'
      let phone = this.$route.query.phone || sessionStorage.getItem('shunyi_user_phone') || this.$store.state.user.profile.phone || ''
      const from = this.$route.query.from || 'wxapp'

      if (!isLoggedIn && !phone) {
        phone = defaultGuestPhone
      }

      if (!phone) {
        Toast('请先登录')
        return
      }

      const loadingToast = Toast.loading({
        message: '检查方案数据...',
        forbidClick: true
      })

      try {
        const planList = await PlanDao.loadList(phone)

        if (!planList || planList.length === 0) {
          loadingToast.clear()
          this.$router.push({
            path: '/shunyi/medical-guidance',
            query: { from }
          })
        } else {
          loadingToast.clear()
          this.$router.push({
            path: '/planListPage',
            query: { from, phone }
          })
        }
      } catch (error) {
        loadingToast.clear()
        console.error('检查方案数据失败:', error)
        this.$router.push({
          path: '/shunyi/medical-guidance',
          query: { from }
        })
      }
    },
    tapDakaHome () {
      const isLoggedIn = this.$store.state.user.profile.isLogin && this.$store.state.user.profile.token
      const defaultGuestPhone = '13610164743'
      const phone = this.$route.query.phone || sessionStorage.getItem('shunyi_user_phone') || this.$store.state.user.profile.phone || ''
      const userId = this.$route.query.userId || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId || ''

      if (!isLoggedIn) {
        const guestPhone = phone || defaultGuestPhone
        const guestUserId = userId || guestPhone
        this.$router.push({
          path: '/PatientDataHomePage',
          query: {
            from: 'wxapp',
            phone: guestPhone,
            userId: guestUserId
          }
        })
        return
      }

      this.$router.push('/PatientDataHomePage')
    },
    tapServicePurchase () {
      this.showServicePurchaseSheet = true
    },
    selectServicePurchase (service) {
      if (!window.wx || !window.wx.miniProgram) {
        Toast('请在顺德健康小程序内打开')
        return
      }

      const content = sessionStorage.getItem('shunyi_internet_hospital_content') || ''

      try {
        window.wx.miniProgram.postMessage({
          data: {
            appId: GUOXIN_MINI_PROGRAM_APP_ID,
            path: `${GUOXIN_MINI_PROGRAM_PAGE_PATH}?id=${service.productId}&content=${encodeURIComponent(content)}`
          }
        })
        window.wx.miniProgram.navigateBack()
      } catch (error) {
        console.error('服务购买小程序中转失败:', error)
        Toast('服务购买入口暂不可用')
      }
    },
    getHospitalById (id) {
      const hospitalList = this.$store.state.miniappWebHospitalList.datas
      for (let i = 0; i < hospitalList.length; i++) {
        if (hospitalList[i].id === id) {
          return hospitalList[i]
        }
      }
      return null
    },
    onIntroClick () {
      if (this.hospital.introductionArticleId) {
        this.$router.push({
          path: '/article/detail',
          query: { id: this.hospital.introductionArticleId }
        })
      } else {
        console.log('没有介绍文章id')
      }
    },
    tapSpineAssessment () {
      const route = '/spine-assessment'
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        if (window.wx?.miniProgram) {
          window.wx.miniProgram.navigateTo({
            url: `/pages/spine_assessment/spine_assessment?from=web&phone=${this.$store.state.user.profile.phone}`
          })
        } else {
          this.$router.push(route)
        }
      } else {
        this.$router.push('/login/index')
      }
    },
    tapRehabPlan () {
      const route = '/spine-rehab-plan'
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    tapHomeRehab () {
      const route = '/ShunyiPatientInfoTable'
      this.$router.push(route)
    },
    tapProgressTrack () {
      const route = '/spine-progress-track'
      const isLogin = this.$store.state.user.profile.isLogin
      if (isLogin) {
        this.$router.push(route)
      } else {
        this.$router.push('/login/index')
      }
    },
    handleBannerClick (banner) {
      if (banner.targetCategoryKey) {
        this.$router.push({
          path: '/shunyi/article/list',
          query: {
            category: banner.targetCategoryKey
          }
        })
      }
    },
    onChange (index) {
      this.current = index
    },
    selectBanner (index) {
      if (this.current === index && this.hospital.bannerList) {
        this.handleBannerClick(this.hospital.bannerList[index])
        return
      }
      this.current = index
      if (this.$refs.swipe) {
        this.$refs.swipe.swipeTo(index)
      }
      this.$toast({
        message: '再次点击进入查看服务详情',
        position: 'bottom',
        duration: 2000
      })
    },
    getBubbleStyle (index) {
      const colors = [
        'linear-gradient(135deg, #A5D6A7 0%, #81C784 100%)',
        'linear-gradient(135deg, #C5E1A5 0%, #9CCC65 100%)',
        'linear-gradient(135deg, #E6EE9C 0%, #D4E157 100%)',
        'linear-gradient(135deg, #FFECB3 0%, #FFD54F 100%)',
        'linear-gradient(135deg, #FFCC80 0%, #FFB74D 100%)'
      ]

      if (this.current === index) {
        return {}
      }

      const colorIndex = index % colors.length
      const rotateValue = -1 + Math.random() * 2
      const translateValue = Math.random() * 0.5
      return {
        background: colors[colorIndex],
        transform: `perspective(800px) rotateX(${rotateValue}deg) rotateY(${rotateValue}deg) translateZ(${translateValue}px)`,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.06), inset 0 1px 2px rgba(255, 255, 255, 0.6)'
      }
    },
    // 根据出生日期计算年龄
    calculateAge (birthDate) {
      if (!birthDate) return 0
      const birth = new Date(birthDate)
      const today = new Date()
      let age = today.getFullYear() - birth.getFullYear()
      const monthDiff = today.getMonth() - birth.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--
      }
      return age < 0 ? 0 : age
    },
    // 静默登录
    async silentLogin (query) {
      // 显示loading
      const toast = Toast.loading({
        message: '正在加载服务',
        forbidClick: true
      })

      try {
        // 计算年龄
        let age = 0
        if (query.age) {
          age = parseInt(query.age) || 0
        } else if (query.birthDate || query.birthday) {
          const birthDate = query.birthDate || query.birthday
          age = this.calculateAge(birthDate)
        }

        // 构建请求参数
        const requestBody = {
          // 预设值
          inviteCode: 25102931,
          hospitalId: 80,
          registHospitalId: 69,
          doctor: '无',
          sickKind: 7,
          registerChannel: '健康顺德小程序H5',
          registerDevice: '健康顺德小程序H5',
          isThirdSys: true,
          thirdSys: '健康顺德',
          age: age
        }

        // 从URL参数获取的值（如果有的话）
        if (query.phone) {
          requestBody.phone = query.phone
        }

        if (query.name) {
          requestBody.name = query.name
        }

        if (query.gender || query.sex) {
          requestBody.sex = query.gender || query.sex
        }

        // 第三方系统用户ID
        if (query.userId) {
          requestBody.thirdSysUserId = query.userId
        }

        console.log('静默登录请求参数:', requestBody)

        // 调用接口
        const url = '/register/patient/web/v2'
        const { data: resp } = await this.$http.post(url, requestBody)
        console.log('静默登录响应:', resp)

        // 关闭loading
        toast.clear()

        // 检查响应
        if (resp && resp.code === 200 && resp.data) {
          const { userId, token, phone } = resp.data

          // 打印返回值
          console.log('静默登录成功 - userId:', userId)
          console.log('静默登录成功 - token:', token)
          console.log('静默登录成功 - phone:', phone)

          // 保存到 store
          const userProfile = {
            isLogin: true,
            userId: userId || '',
            phone: phone || '',
            name: query.name || '',
            token: token || '',
            passwd: '',
            hospitalName: this.hospital.name || ''
          }
          this.$store.commit('user/setUser', userProfile)
          this.$store.commit('user/setToken', token)

          // 保存到 sessionStorage（备用）
          if (userId) {
            sessionStorage.setItem('shunyi_user_id', userId)
          }
          if (token) {
            sessionStorage.setItem('token', token)
            sessionStorage.setItem('shunyi_token', token)
          }
          if (phone) {
            sessionStorage.setItem('shunyi_user_phone', phone)
          }

          console.log('用户信息已保存到 store 和 sessionStorage')
        } else {
          console.error('静默登录失败:', resp?.message || '未知错误')
        }
      } catch (error) {
        // 关闭loading
        toast.clear()
        console.error('静默登录异常:', error)
      }
    }
  },
  computed: {
    userName () {
      const isLoggedIn = this.$store.state.user.profile.isLogin && this.$store.state.user.profile.token
      if (!isLoggedIn) {
        return '游客'
      }
      return this.$route.query.name ||
             sessionStorage.getItem('shunyi_user_name') ||
             this.$store.state.user.profile.name ||
             ''
    },
    displayHospitalName () {
      return this.$route.query.hospitalName ||
             sessionStorage.getItem('shunyi_register_hospital_name') ||
             sessionStorage.getItem('shunyi_hospital_name') ||
             this.$store.state.user.qrCodeHospital ||
             this.hospital.name ||
             ''
    },
    userPhone () {
      return this.$route.query.phone ||
             sessionStorage.getItem('shunyi_user_phone') ||
             this.$store.state.user.profile.phone ||
             ''
    },
    maskedPhone () {
      const phone = this.userPhone
      if (!phone || phone.length < 7) return phone
      return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4)
    }
  }
}
</script>

<style scoped>
.slogan-wrapper {
  width: 100vw;
  box-sizing: border-box;
}

.slogan-img {
  width: 100vw;
  display: block;
  margin: 0 auto;
}

.banner-top-wrapper {
  padding: 0 16px;
  margin-top: 12px;
  box-sizing: border-box;
}

.banner-top-image {
  width: 100%;
  aspect-ratio: 1920 / 823;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transform-origin: center bottom;
}

.banner-top-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-top-image--jelly {
  animation: bannerTopJelly 520ms ease-out;
}

@keyframes bannerTopJelly {
  0% { transform: scale3d(1, 1, 1); }
  30% { transform: scale3d(1.05, 0.94, 1); }
  50% { transform: scale3d(0.96, 1.04, 1); }
  70% { transform: scale3d(1.02, 0.98, 1); }
  100% { transform: scale3d(1, 1, 1); }
}

.shunyi-page {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 32px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  background-color: #f4fbff;
  position: relative;
}

.user-info {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
  text-align: right;
  color: #333;
}

.user-info__name {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info__phone {
  font-size: 12px;
  color: #666;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 16px 16px 0;
  margin-bottom: 0;
}

.spine-service-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.service-item {
  background: white;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s;
}

.service-item:hover {
  transform: translateY(-2px);
}

.service-title {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-top: 8px;
  font-weight: 500;
}

.doctor-list-wrapper {
  opacity: 1;
  background: linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 10%, #F9F9F9 89%, #FFFFFF 100%);
  padding: 16px;
  position: relative;
  z-index: 1;
}

.video-player {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
  margin: 0 auto 16px;
  background-color: #000;
}

.banner-content-wrapper {
  padding: 0;
  width: 100%;
}

.banner {
  width: 100%;
  padding: 16px 16px 0;
  box-sizing: border-box;
}

.swipe-wrapper {
  position: relative;
  width: 100%;
  height: auto; /* 自适应内容高度 */
  border-radius: 8px;
  overflow: hidden;
}

.swipe-container {
  width: 100%;
  height: auto; /* 自适应高度 */
}

.banner-image {
  width: 100%;
  height: auto; /* 图片等比缩放 */
  display: block;
}

/* 覆盖 Vant Swipe 内部固定高度，改为自适应 */
:deep(.van-swipe) {
  height: auto;
}
:deep(.van-swipe__track) {
  height: auto;
}
:deep(.van-swipe-item) {
  height: auto;
}

/* 轮播图左下角标题覆盖样式 */
.banner-title-overlay {
  position: absolute;
  left: 12px;
  bottom: 12px;
  display: inline-block;
  max-width: calc(100% - 24px);
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.3;
  color: #fff;
  z-index: 3;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  backdrop-filter: saturate(120%) blur(1px);
}
@media (min-width: 390px) {
  .banner-title-overlay { font-size: 15px; padding: 7px 14px; }
}
@media (min-width: 430px) {
  .banner-title-overlay { font-size: 16px; padding: 8px 16px; }
}

.custom-indicator {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 1px 10px;
  font-size: 11px;
  color: #707070;
  background: rgba(255, 255, 255, 0.692);
  border-radius: 16px;
  text-align: center;
  z-index: 2;
  letter-spacing: 1px;
}

.banner-titles-wrapper {
  width: 100%;
  padding: 0 16px 8px;
  box-sizing: border-box;
  margin-top: 12px;
}

.banner-titles-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 0;
}

.banner-title-bubble {
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 13px;
  color: rgba(60, 60, 60, 0.9);
  text-align: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08), inset 0 1px 1px rgba(255, 255, 255, 0.5);
  min-width: 0;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  position: relative;
  overflow: hidden;
  will-change: transform, box-shadow;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-shadow: none;
}

.banner-title-bubble.active {
  background: linear-gradient(135deg, #FF9800 0%, #FB8C00 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 6px 12px rgba(251, 140, 0, 0.25), inset 0 1px 3px rgba(255, 255, 255, 0.5);
  transform: translateY(-2px) translateZ(1px);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

 /* 快捷入口按钮 - 横向排列，有质感的圆角背景 */
 .three-btns {
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 12px 16px 20px;
 }
 .three-btns__item {
   flex: 1;
   text-align: center;
   padding: 12px 0;
   border-radius: 12px;
   color: #fff;
   font-size: 13px;
   font-weight: 600;
   letter-spacing: 0;
   line-height: 1.2;
   box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.35);
   user-select: none;
   white-space: nowrap;
 }
 .three-btns__item--green {
   background: linear-gradient(180deg, #41d6b0 0%, #11b58d 100%);
 }
 .three-btns__item--blue {
   background: linear-gradient(180deg, #59a8ff 0%, #2b7de8 100%);
 }
 .three-btns__item--purple {
   background: linear-gradient(180deg, #7c8cff 0%, #5b63e6 100%);
 }
.three-btns__item--orange {
   background: linear-gradient(180deg, #ffb657 0%, #ff8a3d 100%);
 }

.service-purchase-entry {
  margin: -8px 16px 20px;
  padding: 12px 16px;
  color: #ffffff;
  background: #e86045;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(232, 96, 69, 0.2);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.remote-guide-popup {
  width: 280px;
  overflow: hidden;
}

.remote-guide-popup__content {
  padding: 28px 22px 24px;
  text-align: center;
  background: #ffffff;
}

.remote-guide-popup__title {
  color: #1f2933;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.remote-guide-popup__tip {
  margin-top: 8px;
  color: #646566;
  font-size: 13px;
  line-height: 1.5;
}

.remote-guide-popup__qrcode {
  display: block;
  width: 210px;
  height: 210px;
  margin: 18px auto 0;
  object-fit: contain;
  user-select: auto;
  -webkit-user-select: auto;
  -webkit-touch-callout: default;
}

/* 科普园地样式 */
.science-popularization-section {
  margin: 16px;
  padding: 20px 16px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 4px;
}

.section-header__icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-header__title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0;
  letter-spacing: 0.5px;
}

.science-popularization__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.science-popularization__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #E8F4F8;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  overflow: hidden;
  min-height: 100px;
}

.science-popularization__card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 12px 12px 0 0;
  pointer-events: none;
}

.science-popularization__card:active {
  transform: scale(0.96);
}

.science-popularization__card-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.science-popularization__card-icon .icon-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

.science-popularization__card-label {
  font-size: 13px;
  color: #5CB8E6;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  letter-spacing: 0.3px;
  position: relative;
  z-index: 1;
}

/* 响应式布局 */
@media (max-width: 375px) {
  .science-popularization__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .science-popularization__card {
    padding: 14px 6px;
    min-height: 90px;
  }

  .science-popularization__card-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 8px;
  }

  .science-popularization__card-label {
    font-size: 12px;
  }
}

@media (min-width: 414px) {
  .science-popularization__grid {
    gap: 14px;
  }

  .science-popularization__card {
    padding: 18px 10px;
    min-height: 110px;
  }

  .science-popularization__card-icon {
    width: 52px;
    height: 52px;
    margin-bottom: 12px;
  }

  .science-popularization__card-label {
    font-size: 14px;
  }
 }
</style>
